/*
	Main action and action-creators: this concentrates on dispatching the actions, (action creators) and fetching the data (actions).

	* Action creators simply dispatch actions and their arguments
	* Actions fetch data and dispatch action creators
	* Actions can optionally choose which action to dispatch, as a form of error management, eg: dispatch a particular error type
	* Actions cannot mutate data, that is done in reducers

*/
import fetchActions from './fetchActions'
import appActions from './appActions'
import userProfilePublicActions from './userProfilePublicActions'
import userProfileActions from './userProfileActions'
import votesActions from './votesActions'
import reportActions from './reportActions'
import brandActions from './brandActions'
import itemActions from './itemActions'
import authActions from './authActions'

const actions = {
	...fetchActions,
	...authActions,
	...appActions,
	...userProfileActions,
	...userProfilePublicActions,
	...votesActions,
	...reportActions,
	...brandActions,
	...itemActions
}

export default actions



// WEBPACK FOOTER //
// ./src/redux/actionCreators/old_actions/index.js